var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_12074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 11.9c0-3.99 0-5.986.777-7.51A7.125 7.125 0 014.39 1.277C5.914.5 7.91.5 11.9.5h9.2c3.99 0 5.986 0 7.51.777a7.125 7.125 0 013.113 3.113c.777 1.524.777 3.52.777 7.51v9.2c0 3.99 0 5.986-.777 7.51a7.124 7.124 0 01-3.113 3.113c-1.524.777-3.52.777-7.51.777h-9.2c-3.99 0-5.986 0-7.51-.777a7.125 7.125 0 01-3.113-3.113C.5 27.086.5 25.09.5 21.1v-9.2z",
    fill: "#25B89A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 23.895L9.105 16.5 16.5 9.105l7.395 7.395-7.395 7.395zm0-9.455c-1.136 0-2.06.924-2.06 2.06 0 1.136.924 2.06 2.06 2.06 1.136 0 2.06-.924 2.06-2.06 0-1.136-.924-2.06-2.06-2.06zM5.936 15.444a1.498 1.498 0 000 2.112l9.508 9.508c.58.581 1.531.581 2.112 0l9.508-9.508a1.497 1.497 0 000-2.112l-9.508-9.508a1.498 1.498 0 00-2.112 0l-9.508 9.508z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_12074"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h32v32H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.3d28da6ac278c2c7a97c4ed50a8dfb70.svg";
export { ForwardRef as ReactComponent };